import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=058b8e3d&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=058b8e3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058b8e3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('058b8e3d')) {
      api.createRecord('058b8e3d', component.options)
    } else {
      api.reload('058b8e3d', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=058b8e3d&scoped=true&", function () {
      api.rerender('058b8e3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29NY7lCxeBbT6/JS/comp/CookieBox.vue"
export default component.exports